// extracted by mini-css-extract-plugin
export var addButton = "_nm-0";
export var border = "_nm-8";
export var check = "_nm-h";
export var danger = "_nm-6";
export var dropdownContainer = "_nm-1";
export var editModalBody = "_nm-j";
export var footerContainer = "_nm-i";
export var fullWidth = "_nm-a";
export var hide = "_nm-9";
export var icon = "_nm-3";
export var input = "_nm-7";
export var inputFlex = "_nm-b";
export var inputWrapper = "_nm-c";
export var manualFocus = "_nm-5";
export var optionButton = "_nm-4";
export var pillWrapper = "_nm-e";
export var pointer = "_nm-2";
export var showOverflow = "_nm-f";
export var tagsFlex = "_nm-d";
export var xButton = "_nm-g";